import React from 'react';
import { useTranslation } from 'react-i18next';

import Notification from '../Notification/Notification';

const NotificationCase = ({
  item,
  avatars,
  altAvatars,
  dot,
  onClick,
  formattedDate,
  description,
  currentUser,
  status,
}) => {
  const { t } = useTranslation('common');

  const renderNotificationCase = () => {
    switch (item.notification_type) {
      case 'organization_invite':
        return (
          <Notification
            org={avatars.orgAvatar}
            altOrg={altAvatars.altOrgAvatar}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.organizationInvite', { name: item.name, role: item.extra?.role })}
          />
        );

      case 'will_interview_you':
        return (
          <Notification
            org={avatars.orgAvatar}
            altOrg={altAvatars.altOrgAvatar}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.willInterviewYou', { description })}
          />
        );

      case 'will_interview_him':
        return (
          <Notification
            org={avatars.userAvatarImage}
            altOrg={altAvatars.altUserAvatarImage}
            user={avatars.orgAvatarInterviewHim}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.willInterviewHim', {
              firstName: currentUser.first_name,
              name: item.name,
              description,
            })}
          />
        );

      case 'applied_on_job':
        return (
          <Notification
            org={avatars.userAvatarApplied}
            altOrg={altAvatars.altUserAvatarApplied}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.appliedOnJob', { jobName: item.extra.job.name })}
          />
        );

      case 'employer_job_applied':
        return (
          <Notification
            org={avatars.userAvatarEmployer}
            altOrg={altAvatars.altUserAvatarEmployer}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.employerJobApplied', {
              applicantName: item.extra.applicant.name,
              jobName: item.extra.job.name,
            })}
          />
        );

      case 'connection_requested':
        return (
          <Notification
            org={avatars.userAvatarImageUser}
            altOrg={altAvatars.altUserAvatarImageUser}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.connectionRequested', {
              name: item.name,
              status,
              result:
                item.status === 'accepted' ? t('notificationMessages.accepted') : t('notificationMessages.rejected'),
            })}
          />
        );

      case 'connection_connected':
        return (
          <Notification
            org={avatars.userAvatarImageUser}
            altOrg={altAvatars.altUserAvatarImageUser}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.connectionConnected', { name: item.name })}
          />
        );

      case 'referral_liked':
        return (
          <Notification
            org={avatars.userAvatarImageUser}
            altOrg={altAvatars.altUserAvatarImageUser}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.referralLiked', { name: item.name })}
          />
        );

      case 'applied_refer':
        return (
          <Notification
            org={avatars.userAvatarImageUser}
            altOrg={altAvatars.altUserAvatarImageUser}
            user={avatars.orgAvatarInterviewHim}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.appliedRefer', { name: item.name })}
          />
        );

      case 'applied_without_refer':
        return (
          <Notification
            org={avatars.userAvatarEmployer}
            altOrg={altAvatars.altUserAvatarEmployer}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.appliedWithoutRefer', { applicantName: item.extra.applicant.name })}
          />
        );

      case 'declined_refer':
        return (
          <Notification
            org={avatars.userAvatarImageUser}
            altOrg={altAvatars.altUserAvatarImageUser}
            user={avatars.orgAvatarReferral}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.declinedRefer', {
              name: item.name,
              jobName: item.extra.job.name || item.extra.job.title,
            })}
          />
        );

      case 'declined_after_interview_candidate':
        return (
          <Notification
            org={avatars.orgAvatarInterviewHim}
            altOrg={altAvatars.altOrgAvatarInterviewHim}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.declinedAfterInterviewCandidate', { jobName: item.extra.job.name })}
          />
        );

      case 'declined_after_interview_referral':
        return (
          <Notification
            org={avatars.orgAvatarInterviewHim}
            altOrg={altAvatars.altOrgAvatarInterviewHim}
            user={avatars.userAvatarEmployer}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.declinedAfterInterviewReferral', {
              applicantName: item.extra.applicant.name,
              jobName: item.extra.job.name,
            })}
          />
        );

      case 'declined_after_applied_candidate':
        return (
          <Notification
            org={avatars.orgAvatarInterviewHim}
            altOrg={altAvatars.altOrgAvatarInterviewHim}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.declinedAfterAppliedCandidate', { jobName: item.extra.job.name })}
          />
        );

      case 'declined_after_applied_referral':
        return (
          <Notification
            org={avatars.orgAvatarInterviewHim}
            altOrg={altAvatars.altOrgAvatarInterviewHim}
            user={avatars.userAvatarEmployer}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.declinedAfterAppliedReferral', {
              applicantName: item.extra.applicant.name,
              jobName: item.extra.job.name,
            })}
          />
        );

      case 'role_changed':
        return (
          <Notification
            org={avatars.orgAvatarInterviewHim}
            altOrg={altAvatars.altOrgAvatarInterviewHim}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.roleChanged', {
              changedBy: item.extra.changed_by,
              roleName: item.extra.role_name,
              orgName: item.extra.org_name,
            })}
          />
        );

      case 'pending_referral_reminder':
        return (
          <Notification
            org={avatars.orgAvatarInterviewHim}
            altOrg={altAvatars.altOrgAvatarInterviewHim}
            user={avatars.userAvatarReferral}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.pendingReferralReminder', {
              name: item.name,
              jobTitle: item.extra.job_title,
            })}
          />
        );

      case 'pending_referral_about_to_expire':
        return (
          <Notification
            org={avatars.orgAvatarInterviewHim}
            altOrg={altAvatars.altOrgAvatarInterviewHim}
            user={avatars.userAvatarReferral}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.pendingReferralAboutToExpire', {
              name: item.name,
              jobTitle: item.extra.job_title,
            })}
          />
        );

      case 'pending_referral_has_expired':
        return (
          <Notification
            org={avatars.orgAvatarInterviewHim}
            altOrg={altAvatars.altOrgAvatarInterviewHim}
            user={avatars.userAvatarReferral}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.pendingReferralHasExpired', {
              name: item.name,
              jobTitle: item.extra.job_title,
            })}
          />
        );

      case 'pending_referral_has_expired_for_referral_provider':
        return (
          <Notification
            org={avatars.userAvatarCandidate}
            altOrg={altAvatars.altUserAvatarCandidate}
            user={avatars.orgAvatarInterviewHim}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.pendingReferralExpiredForProvider', {
              jobTitle: item.extra.job_title,
              name: item.name,
            })}
          />
        );

      case 'offered':
        return (
          <Notification
            org={avatars.orgAvatarInterviewHim}
            altOrg={altAvatars.altOrgAvatarInterviewHim}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.offered', {
              jobName: item.extra.job.name,
              orgName: item.extra.organization.title,
            })}
          />
        );

      case 'referral_got_offer':
        return (
          <Notification
            org={avatars.orgAvatarInterviewHim}
            altOrg={altAvatars.altOrgAvatarInterviewHim}
            user={avatars.userAvatarEmployer}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.referralGotOffer', {
              applicantName: item.extra.applicant.name,
              jobName: item.extra.job.name,
              orgName: item.extra.organization.title,
            })}
          />
        );

      case 'you_were_hired':
        return (
          <Notification
            org={avatars.orgAvatar}
            altOrg={altAvatars.altOrgAvatar}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.youWereHired', { name: item.name })}
          />
        );

      case 'employer_hired_candidate':
        return (
          <Notification
            org={avatars.userAvatarEmployer}
            altOrg={altAvatars.altUserAvatarEmployer}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.employerHiredCandidate', {
              applicantName: item.extra.applicant.name,
              jobName: item.extra.job.name,
              orgName: item.extra.organization.title,
            })}
          />
        );

      case 'one_got_hired':
        return (
          <Notification
            org={avatars.orgAvatarInterviewHim}
            altOrg={altAvatars.altOrgAvatarInterviewHim}
            user={avatars.userAvatarImage}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.oneGotHired', { name: item.name, orgName: item.extra.organization.title })}
          />
        );

      case 'bounty_amount_changed':
        return (
          <Notification
            org={avatars.userAvatarEmployer}
            altOrg={altAvatars.altUserAvatarEmployer}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.bountyAmountChanged', {
              changedBy: item.extra.changed_by,
              name: item.extra.name,
              oldAmount: item.extra.old_amount,
              newAmount: item.extra.new_amount,
            })}
          />
        );

      case 'bounty_period_changed':
        return (
          <Notification
            org={avatars.userAvatarEmployer}
            altOrg={altAvatars.altUserAvatarEmployer}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.bountyPeriodChanged', {
              changedBy: item.extra.changed_by,
              name: item.extra.name,
              oldPeriod: item.extra.old_period,
              newPeriod: item.extra.new_period,
            })}
          />
        );
      case 'referred_you':
        return (
          <Notification
            org={avatars.userAvatarReferral}
            altOrg={altAvatars.altUserAvatarReferral}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.referredYou', { name: item.name })}
          />
        );
      case 'connection_disconnected':
        return (
          <Notification
            org={avatars.userAvatarImageUser}
            altOrg={altAvatars.altUserAvatarImageUser}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.connectionDisconnected', { name: item.name })}
          />
        );
      case 'referred_on_job':
        return (
          <Notification
            org={avatars.userAvatarReferral}
            altOrg={altAvatars.altUserAvatarReferral}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.referredOnJob', {
              providerName: item.extra.referral_provider_name,
              jobTitle: item.extra.job.title,
            })}
          />
        );

      case 'declined_refer_for_employer':
        return (
          <Notification
            org={avatars.userAvatarEmployer}
            altOrg={altAvatars.altUserAvatarEmployer}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.declinedReferForEmployer', {
              applicantName: item.extra.applicant.name,
              jobName: item.extra.job.name,
            })}
          />
        );

      case 'referral_bonus_payment_due_six_day':
        return (
          <Notification
            org={avatars.userAvatarImageUser}
            altOrg={altAvatars.altUserAvatarImageUser}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.referralBonusPaymentDueSixDays', {
              referralProvider: item.extra.referral_provider,
              candidateName: item.extra.candidate_name,
              jobTitle: item.extra.job_title,
            })}
          />
        );

      case 'referral_bonus_payment_due_one_day':
        return (
          <Notification
            org={avatars.userAvatarImageUser}
            altOrg={altAvatars.altUserAvatarImageUser}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.referralBonusPaymentDueOneDay', {
              referralProvider: item.extra.referral_provider,
              candidateName: item.extra.candidate_name,
              jobTitle: item.extra.job_title,
            })}
          />
        );

      case 'referral_bonus_payment_paid':
        return (
          <Notification
            org={avatars.userAvatarImageUser}
            altOrg={altAvatars.altUserAvatarImageUser}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.referralBonusPaymentPaid', {
              candidateName: item.extra.candidate_name,
              jobTitle: item.extra.job_title,
            })}
          />
        );

      case 'referral_bonus_payment_past_due_date':
        return (
          <Notification
            org={avatars.userAvatarImageUser}
            altOrg={altAvatars.altUserAvatarImageUser}
            dot={dot}
            item={item}
            date={formattedDate}
            onClick={onClick}
            text={t('notificationMessages.referralBonusPaymentPastDue', {
              candidateName: item.extra.candidate_name,
              jobTitle: item.extra.job_title,
            })}
          />
        );

      default:
        return null;
    }
  };
  return renderNotificationCase();
};
export default NotificationCase;
